<template>
    <div class="stepFourRoot">
      <div class="circleItem"><CircleVue currentIndex="4"></CircleVue> </div>
      <div class="backPageItem"><BackPageVue  @backPreviewPage="hanldGoBack"></BackPageVue> </div>

        <div>
            <div class="titleLine">Let’s Personalize Your Promotion Plan</div>
            <div class="subTitle"> Tell us about your research field so we can recommend strategies that match your goals and field. </div>
        </div>

        <!-- <div class="fieldLine">What is your research field?</div> -->
      
        <div class="cascadeSelect">
            <!-- 一级选择器 -->
    <el-select 
      v-model="primaryValue" 
      placeholder="Domain"
      @change="handlePrimaryChange"
      clearable
    >
      <el-option
        v-for="item in primaryOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    
    <!-- 二级选择器 -->
    <el-select 
      v-model="secondaryValue" 
      placeholder="Field"
      :disabled="!primaryValue"
      clearable
    >
      <el-option
        v-for="item in secondaryOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
        </div>
      
      <div class="btnLine">
        <div class="disBtn" v-if="!secondaryValue">Next</div>
        <div class="chooseBtn" v-else @click="goToNextStep">Next</div>
      </div>
      <div class="LastLine">
          <div class="skipBtn" @click="goToNextStep">Skip</div>
      </div>
      <div class="LastLine2">
          <div class="oneItem">©  2012-2026 PaperSpotlight. All rights reserved.</div>
          <!-- <div class="twoItem">The data presented is based on our independent research and analysis. While we strive for accuracy, results may vary across different fields and contexts. Unauthorized reproduction or distribution of this content is prohibited.</div> -->
      </div>
    </div>
</template>
<script>
import CircleVue from './circle.vue'
import BackPageVue from './backPage.vue'

export default {
    components:{CircleVue,BackPageVue},
    data(){
      return{
        imgObj:{
          guideHomebg1:require("../../assets/img/main/guideHomebg1.png"),
          guideHomebg2:require("../../assets/img/main/guideHomebg2.png"),
        },
       
        primaryValue: '',      // 一级选择的值
      secondaryValue: '',    // 二级选择的值
      primaryOptions: [      // 一级选项
        { value: 'AppliedSciences', label: 'Applied Sciences' },
        { value: 'ArtsHumanities', label: 'Arts & Humanities' },
        { value: 'EconomicSocialSciences', label: 'Economic & Social Sciences' },
        { value: 'HealthSciences', label: 'Health Sciences' },
        { value: 'NaturalSciences', label: 'Natural Sciences' },

      ],
      // 所有二级选项数据
      allSecondaryOptions: {
        AppliedSciences: [
          { value: 'Agriculture, Fisheries & Forestry', label: 'Agriculture, Fisheries & Forestry' },
          { value: 'Built Environment & Design', label: 'Built Environment & Design' },
          { value: 'Enabling & Strategic Technologies', label: 'Enabling & Strategic Technologies' },
          { value: 'Engineering', label: 'Engineering' },
          { value: 'Information & Communication Technologies', label: 'Information & Communication Technologies' },
        ],
        ArtsHumanities: [
          { value: 'Communication & Textual Studies', label: 'Communication & Textual Studies' },
          { value: 'Historical Studies', label: 'Historical Studies' },
          { value: 'Philosophy & Theology', label: 'Philosophy & Theology' },
          { value: 'Visual & Performing Arts', label: 'Visual & Performing Arts' },
        ],
        EconomicSocialSciences: [
          { value: 'Economics & Business', label: 'Economics & Business' },
          { value: 'Social Sciences', label: 'Social Sciences' },
        ],
        HealthSciences: [
          { value: 'Biomedical Research', label: 'Biomedical Research' },
          { value: 'Clinical Medicine', label: 'Clinical Medicine' },
          { value: 'Psychology & Cognitive Sciences', label: 'Psychology & Cognitive Sciences' },
          { value: 'Public Health & Health Services', label: 'Public Health & Health Services' },
        ],
        NaturalSciences: [
          { value: 'Biology', label: 'Biology' },
          { value: 'Chemistry', label: 'Chemistry' },
          { value: 'Earth & Environmental Sciences', label: 'Earth & Environmental Sciences' },
          { value: 'Mathematics & Statistics', label: 'Mathematics & Statistics' },
          { value: 'Physics & Astronomy', label: 'Physics & Astronomy' }
        ]
      },
      secondaryOptions: []   // 当前显示的二级选项
        
      }
  },
  mounted: function() {
    let userData = JSON.parse(localStorage.getItem('userData'))
    if(userData&&userData.stepFour&&userData.stepFour.length){
      this.primaryValue = userData&&userData.stepFour&&userData.stepFour[0]
      this.handlePrimaryChange(  this.primaryValue)
      this.secondaryValue = userData&&userData.stepFour&&userData.stepFour[1]

    }
  },
  methods:{
    hanldGoBack(){
      localStorage.setItem('guideIndex', 3);
      this.$emit('changePage', 3);
    },
     // 一级选择变化时触发
     handlePrimaryChange(value) {
      console.log(value)
      this.secondaryValue = ''; // 清空二级选择
      // 根据一级选择的值更新二级选项
      this.secondaryOptions = this.allSecondaryOptions[value] || [];
    },
    goToNextStep(){
      localStorage.setItem('guideIndex', 5);
      let userData = JSON.parse(localStorage.getItem('userData'))
      if(this.secondaryValue){
        userData.stepFour = [this.primaryValue,this.secondaryValue] 
        let str = JSON.stringify(userData)
        localStorage.setItem('userData', str);
      }else{
        userData.stepFour = []
        let str = JSON.stringify( userData)
        localStorage.setItem('userData', str);
          
      }
      this.$emit('changePage', 5);
    }
  }
}
</script>

<style lang="scss">
.el-select-dropdown__item.selected {
  color: #FEAE00 !important;
}
.stepFourRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 0 30px 0 ;
    gap: 50px;
    position: relative;
    .backPageItem{
      position: absolute;
      left: 100px;
      top:40px;
      width: 30px;
      height: 30px;
    }
    .circleItem{
      position: absolute;
      right: 100px;
      top:40px;
      width: 50px;
      height: 50px;
    }
    .titleLine{
      color: #000;
      text-align: center;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .subTitle{
        margin-top: 10px;
        max-width: 900px;
        color: var(---2, #333);
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
    }
    .fieldLine{
        color: var(---2, #333);
        text-align: center;

        /* 一级标题 */
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
    }
   .cascadeSelect{
        display: flex;
        gap: 20px;
        .el-select{
            width: 320px;
        }
   }
    .btnLine{
          display: flex;
        justify-content: center;
        align-items: center;
        .disBtn{
            display: inline-block;
            background: #E0E0E0;
            color: #fff;
            padding: 12px 40px;
            border-radius: 8px;
            font-size: 16px;
        }
        .chooseBtn{
            cursor: pointer;
            display: inline-block;
            background: #212121;
            color: #fafafa;
            padding: 12px 40px;
            border-radius: 8px;
            font-size: 16px;
        }
        .chooseBtn:hover{
            background: #424242;
        }
        .chooseBtn:active{
            background: #212121;
        }
        

    }
    .LastLine{
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-top: -50px;
      .skipBtn{
          cursor: pointer;
          padding: 12px 40px;
            font-size: 16px;
            color: #999;
        }
      }
    .LastLine2{
      flex: 1 1;
      display: flex;
        justify-content: center;
        align-items: flex-end;
        // margin-top: -20px;
        .oneItem{
          color: var(---1, #000);
          text-align: center;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px; /* 110% */
        }
        .twoItem{
          width: 90%;
          max-width: 900px;
          color: #aaa;
          text-align: center;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
    }
}
@media screen and (max-width:767px) { 
  .stepFourRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20vw 6vw 10vw 6vw;
  gap: 10vw;
    position: relative;
    .backPageItem{
      position: absolute;
      left: 2vw;
      top:3vw;
      width: 4vw;
      height: 4vw;
    }
    .circleItem{
      position: absolute;
      right: 2vw;
      top:3vw;
      width: 8vw;
      height: 8vw;
    }
    .titleLine{
      color: #000;
      text-align: center;
      font-size: 6vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .subTitle{
        margin-top: 2vw;
        max-width: 900px;
        color: var(---2, #333);
        text-align: center;
        font-size: 3.4vw;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
    }
    .fieldLine{
        color: var(---2, #333);
        text-align: center;

        /* 一级标题 */
        font-size: 4.6vw;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
    }
   .cascadeSelect{
        display: flex;
        flex-direction: column;
        gap: 5vw;
        .el-select{
            width: 320px;
        }
   }
    .btnLine{
          display: flex;
        justify-content: center;
        align-items: center;
        .disBtn{
            display: inline-block;
            background: #E0E0E0;
            color: #fff;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 3.4vw;
        }
        .chooseBtn{
            cursor: pointer;
            display: inline-block;
            background: #212121;
            color: #fafafa;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 3.4vw;
        }
        .chooseBtn:hover{
            background: #424242;
        }
        .chooseBtn:active{
            background: #212121;
        }
        

    }
    .LastLine{
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-top: -6vw;
      .skipBtn{
          cursor: pointer;
          padding: 1.2vw 4vw;
            font-size: 3.4vw;
            color: #999;
        }
      }
      .LastLine2{
        flex: 1 1;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // margin-top: -4vw;
        .oneItem{
            color: var(---1, #000);
            text-align: center;
            font-size: 3.4vw;
            font-style: normal;
            font-weight: 400;
            line-height: 1.3; /* 110% */
          }
          .twoItem{
            width: 90%;
            max-width: 900px;
            color: #aaa;
            text-align: center;
            font-size: 3vw;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
    }
}
}


@media screen  and (min-width: 767px) and (max-width: 1200px){
  .stepFourRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 6vw 0 3vw 0;
    gap: 5vw;
    position: relative;
    .backPageItem{
      position: absolute;
      left: 6vw;
      top:2vw;
      width: 5vw;
      height: 5vw;
    }
    .circleItem{
      position: absolute;
      right: 6vw;
      top:2vw;
      width: 5vw;
      height: 5vw;
    }
    .titleLine{
      color: #000;
      text-align: center;
      font-size: 3.2vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .subTitle{
        margin-top: 10px;
        max-width: 650px;
        color: var(---2, #333);
        text-align: center;
        font-size: 1.6vw;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
    }
    .fieldLine{
        color: var(---2, #333);
        text-align: center;

        /* 一级标题 */
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
    }
   .cascadeSelect{
        display: flex;
        gap: 2vw;
        .el-select{
            width: 320px;
        }
   }
    .btnLine{
          display: flex;
        justify-content: center;
        align-items: center;
        .disBtn{
            display: inline-block;
            background: #E0E0E0;
            color: #fff;
            padding: 1,2vw 4vw;
            border-radius: 8px;
            font-size: 1.6vw;
        }
        .chooseBtn{
            cursor: pointer;
            display: inline-block;
            background: #212121;
            color: #fafafa;
            padding: 1,2vw 4vw;
            border-radius: 8px;
            font-size: 1.6vw;
        }
        .chooseBtn:hover{
            background: #424242;
        }
        .chooseBtn:active{
            background: #212121;
        }
        

    }
    .LastLine{
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-top: -5vw;
      .skipBtn{
          cursor: pointer;
          padding: 1.2vw 4vw;
            font-size: 1.6vw; 
            color: #999;
        }
      }
      .LastLine2{
        flex: 1 1;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        // margin-top: -1vw;
        .oneItem{
          color: var(---1, #000);
          text-align: center;
          font-size: 1.6vw;
          font-style: normal;
          font-weight: 400;
          line-height: 1.3; /* 110% */
        }
        .twoItem{
          width: 90%;
          max-width: 900px;
          color: #aaa;

          text-align: center;
          font-size: 1.2vw;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
    }
}
}
</style>